/*
 * The tender quote duration module
 */
var TECL_TenderQuoteDuration = {

  MatChildOrgsFetched: false,
  LastMatOrgIdSelected: null,

  // Initialise the page
  Initialise: function () {
    TECL_TenderGeneral.HidePleaseWaitDlg();

    TECL_TenderGeneral.InitialiseAccordionControls();

    TECL_TenderQuoteDuration.UpdateSummaryBox();

    // Make the date section alternate depending on the checkboxes selection
    $("#sameDayTenderQuote").change(function () {
      if (this.checked) {
        $("#sameDateSection").removeClass("hidden");
        $("#quotePerProductDates").addClass("hidden");
      } else {
        $("#sameDateSection").addClass("hidden");
        $("#quotePerProductDates").removeClass("hidden");
      }

      TECL_TenderQuoteDuration.UpdateSummaryBox();
    });

    window.scrollTo(0, 0);

    // Default the user control disabled state
    TECL_TenderQuoteDuration.UpdateQuoteDurationItemsState();

    // enable and disable the user defined date on radio button change
    $("#quoteDurationShortTerm").change(function () {

      TECL_TenderQuoteDuration.UpdateQuoteDurationItemsState();
    });

    $("#quoteDurationMidTerm").change(function () {
      TECL_TenderQuoteDuration.UpdateQuoteDurationItemsState();
    });

    $("#quoteDurationLongTerm").change(function () {
      TECL_TenderQuoteDuration.UpdateQuoteDurationItemsState();
    });

    $("#quoteDurationUserDefinedTerm").change(function () {
      TECL_TenderQuoteDuration.UpdateQuoteDurationItemsState();
    });

    $(".quoteDurationItem").click(function () {
      $(this).find("[type='radio']").prop("checked", true);
      TECL_TenderQuoteDuration.UpdateQuoteDurationItemsState();
    });

    $("#sameDateLatestDateVal").blur(function () {
      TECL_TenderQuoteDuration.UpdateSummaryBox();
    });

    TECL_TenderGeneral.InitialiseStickySidebar();

    TECL_DateTime.InitialiseDateTimePickers("#tenderPage");

    // Initialise Org selection section
    TECL_TenderQuoteDuration.InitialiseOrgSelectionSection();
  },

  /*
   * Method used to initialise the Organisation selection section on the quote duration page
   */
  InitialiseOrgSelectionSection: function () {

    var $singleSchoolSearch = $("#singleSchoolSearch");
    var $matSchoolSearch = $("#matSchoolSearch");
    var $orgSelectionOptionsContainer = $("#tenderOrgSelectionSection");

    // Validation fields
    var $singleSchoolNotSearched = $("#errSingleSchoolNotSearched");
    var $matSchoolNotSearched = $("#errMatSchoolNotSearched");
    var $matSchoolNotSelected = $("#errMatSchoolsNotSelected");

    // Handle MAT child school options changing
    $("body").on("change.selectMatOrgs", ".mat-school-options .checkbox:not(.select-all) input:visible", function () {

      // Hide the relevant validation
      $matSchoolNotSelected.addClass("hidden");

      $(this).closest(".checkbox").toggleClass("item-checked", this.checked);
      // Update the summary box
      TECL_TenderQuoteDuration.UpdateSummaryBox();
    });

    // Handle MAT child school options select all
    $("body").on("change.selectMatOrgs", ".mat-school-options .checkbox.select-all input", function () {
      var checked = this.checked;
      $(".mat-school-options .checkbox:not(.select-all) input:visible").each(function () {
        var $inputToChange = $(this);
        $inputToChange.prop("checked", checked);
        // Fire change event
        $inputToChange.change();
      });
    });

    // If MAT is selected on start, then we need to get the selectable options
    if ($matSchoolSearch.is(":visible")) {
      TECL_TenderQuoteDuration.MatSchoolSelected($("#matSchoolSearchOrgId").val());
    }

    // Initialise the Org searches
    TECL_OrgQuickSearch.Initialise($singleSchoolSearch);
    TECL_OrgQuickSearch.Initialise($matSchoolSearch, {
      ReturnMatOnly: true
    });

    // Handle when an org selection option is clicked
    $orgSelectionOptionsContainer.find(".radio-btn-item").click(function () {
      // Hide relevant validation
      $singleSchoolNotSearched.addClass("hidden");
      $matSchoolNotSearched.addClass("hidden");
      $matSchoolNotSelected.addClass("hidden");

      var $radioOption = $(this);

      if (!$radioOption.hasClass("selected")) {

        $orgSelectionOptionsContainer.find(".radio-btn-item.selected").removeClass("selected");
        $orgSelectionOptionsContainer.find("input[type='radio']").prop("checked", false);
        $radioOption.find("input[type='radio']").prop("checked", true);
        $radioOption.addClass("selected");

        // Clear school search inputs
        $radioOption.find(".school-search-wrapper input").each(function () {
          $(this).val(null);
        });

        // Update the summary box
        TECL_TenderQuoteDuration.UpdateSummaryBox();

        // Create with null to clear if needed
        TECL_TenderQuoteDuration.CreateMatChildOptions(null);
      }
    });

    // Handle when an MAT Org search result is selected
    $matSchoolSearch.on("itemSelected", function (event, orgId, orgName, postcode) {
      // Hide relevant validation
      $singleSchoolNotSearched.addClass("hidden");
      $matSchoolNotSearched.addClass("hidden");
      $matSchoolNotSelected.addClass("hidden");

      if (orgId !== TECL_TenderQuoteDuration.LastMatOrgIdSelected || !TECL_TenderQuoteDuration.MatChildOrgsFetched) {
        TECL_TenderQuoteDuration.MatSchoolSelected(orgId);
      }
    });

    // Handle when a single Org search result is selected
    $singleSchoolSearch.on("itemSelected", function (event, orgId, orgName, postcode) {
      // Hide relevant validation
      $singleSchoolNotSearched.addClass("hidden");
      $matSchoolNotSearched.addClass("hidden");

      // Set the Org Id value
      $("#singleSchoolSearchOrgId").val(orgId);
      // Update the summary box
      TECL_TenderQuoteDuration.UpdateSummaryBox();
    });
  },

  /*
   * Handles when the MAT school is selected
   */
  MatSchoolSelected: function (orgId) {

    // Set the Org Id value
    TECL_TenderQuoteDuration.MatChildOrgsFetched = false;
    $("#matSchoolSearchOrgId").val(orgId);
    var childOrgs = [];

    // If we have a MAT school
    if (orgId && orgId.length > 0) {
      TECL_TenderQuoteDuration.MatChildOrgsFetched = true;
      TECL_TenderQuoteDuration.LastMatOrgIdSelected = orgId;
      childOrgs = TECL_OrgSearch.GetChildOrgs(orgId);
    }

    // Create child options
    // If there are no child orgs, previous will be wiped
    TECL_TenderQuoteDuration.CreateMatChildOptions(childOrgs);

    // Update the summary box
    TECL_TenderQuoteDuration.UpdateSummaryBox();
  },

  /*
   * Method used to create selectable options for the MAT school search
   */
  CreateMatChildOptions: function (orgs) {

    // Clear any current options
    var $matSchoolOptions = $(".mat-school-options");
    var $selectAllOption = $matSchoolOptions.find(".checkbox.select-all");
    $matSchoolOptions.find(".checkbox:not(.select-all):visible").remove();

    // Set to default and hide
    $selectAllOption.find("input").prop("checked", false);
    $selectAllOption.addClass("hidden");
    $matSchoolOptions.addClass("hidden");

    // If we have orgs
    if (orgs && orgs.length > 0) {

      $matSchoolOptions.removeClass("hidden");
      $selectAllOption.removeClass("hidden");
      var $blankCheckbox = $(".mat-school-options .checkbox:not(:visible)");

      for (var i = 0; i < orgs.length; i++) {

        var orgItem = orgs[i];
        var $blankClone = $blankCheckbox.clone();

        // Unhide
        $blankClone.removeClass("hidden");

        // Add the OrgId
        $blankClone.attr("data-orgId", orgItem.OrgId);

        // Get first label and write org name
        var $firstLabel = $blankClone.find("label");
        $firstLabel.prepend(orgItem.Name);

        // Get postcode span and write
        $firstLabel.find("span").first().html(orgItem.Postcode);

        // Add the checkbox
        $(".mat-school-options").append($blankClone);
      }
    }
    TECL_TenderQuoteDuration.UpdateSummaryBox();
  },

  /*
   * Method used to update the summary box
   */
  UpdateSummaryBox: function () {
    var implementationDate;
    var quoteDuration = "";
    var notSet = "Not set";

    if ($("#sameDayTenderQuote").prop("checked")) {
      implementationDate = $("#sameDateLatestDateVal").val();
    } else {
      implementationDate = "Custom";
    }

    var quoteDurationElement = $(".quoteDurationSelection").find(":checked");
    if (quoteDurationElement != null) {
      var quoteDurationVal = quoteDurationElement.val();

      switch (quoteDurationVal) {
        case "LongTerm":
          quoteDuration = "6 weeks";
          break;

        case "MidTerm":
          quoteDuration = "4 weeks";
          break;

        case "ShortTerm":
          quoteDuration = "2 weeks";
          break;

        default:
          quoteDuration = "Until " + $("#quoteUserDefinedDate").val();
      }
    }

    // Date summary
    var $implementationDateSummary = $("#implementationDateSummary");
    if (implementationDate) {
      $implementationDateSummary.text(implementationDate);
      $implementationDateSummary.removeClass("invalid");
    } else {
      $implementationDateSummary.text(notSet);
      $implementationDateSummary.addClass("invalid");
    }
    $("#quoteDurationSummary").text(quoteDuration);

    // Selected Orgs
    // Determine which option is currently selected
    var $singleSchoolSearch = $("#singleSchoolSearch");
    var singleSchool = $singleSchoolSearch.is(":visible");
    var orgUpdateText = notSet;
    var isInvalid = true;

    if (singleSchool) {

      // If we have an Org Id value
      if ($("#singleSchoolSearchOrgId").val()) {

        // Ensure there is an Org name, to avoid confusion
        if ($singleSchoolSearch.val()) {

          // Get the postcode
          orgUpdateText = $singleSchoolSearch.attr("data-pcode");
          isInvalid = false;
        } else {

          // If there is no Org name, clear the Org Id details
          $("#singleSchoolSearchOrgId").val(null);
          $singleSchoolSearch.attr("data_id", null);
        }
      }
    } else {

      // MAT school option
      var $visibleSelectedOptions = $(".mat-school-options .checkbox:not(.select-all).item-checked:visible");

      if ($visibleSelectedOptions.length === 1) {
        orgUpdateText = $visibleSelectedOptions.first().find("label span:first-child").html();
        isInvalid = false;
      } else if ($visibleSelectedOptions.length > 1) {
        orgUpdateText = $visibleSelectedOptions.length;
        isInvalid = false;
      }
    }
    // Update the org field in the summary box
    var $orgSummaryTextHolder = $("#selectedOrgSummary");
    $orgSummaryTextHolder.text(orgUpdateText);
    $orgSummaryTextHolder.toggleClass("invalid", isInvalid);
  },

  // Update the disabled state of the user defined term date
  UpdateQuoteDurationItemsState: function () {

    $(".quoteDurationSelection").children(".quoteDurationItem").removeClass("selected");
    $(".quoteDurationSelection").find(":checked").parents(".quoteDurationItem").addClass("selected");

    var checked = $("#quoteDurationUserDefinedTerm").prop("checked");
    if (checked) {
      $("#quoteUserDefinedDate").prop('disabled', false);
    } else {
      $("#quoteUserDefinedDate").prop('disabled', true);
    }

    TECL_TenderQuoteDuration.UpdateSummaryBox();
  },

  // Continue to the next stage
  ContinueToNextStage: function () {

    if (TECL_TenderQuoteDuration.ValidatePage()) {

      // Post back to change page view
      var cacheId = $("#cacheId").val();

      // Serialise data
      var quoteDurationData = TECL_TenderQuoteDuration.SerialisedData();

      var $loggedInWithOrgInfo = $("#isLoggedInWithOrg");
      var loggedInWithOrg = $loggedInWithOrgInfo.val() === "true";
      var continueToCall = true;

      if (loggedInWithOrg && (quoteDurationData.SelectedOrgId !== $loggedInWithOrgInfo.attr("data-orgId"))) {

        // Selected org is different to the account's org
        continueToCall = false;
        var $modal = $("#accountOrgChangingDlg");

        // Setup the confirm button
        $modal.find(".btn-ok").off("click").on("click", function () {
          // Continue to next stage
          TECL_TenderQuoteDuration.ContinueToNextStageCall(cacheId, quoteDurationData);
          $modal.modal("hide");
        });
        $modal.modal("show");
      }

      if (continueToCall) {

        // Continue to next stage
        TECL_TenderQuoteDuration.ContinueToNextStageCall(cacheId, quoteDurationData);
      }
    }
  },

  /*
   * Method used to continue to the next stage
   * Does not validate
   */
  ContinueToNextStageCall: function (cacheId, quoteDurationData) {

    if (TECL_Master.AddLock("ContinueNextStageSelectSuppliers")) {
      TECL_TenderGeneral.DisplayPleaseWaitDlg();

      // Call Server to add the product request to the cache and reload the product request list
      $.ajax({
        url: baseSiteUrl + "umbraco/Surface/Tender/ContinueNextStageSelectSuppliers",
        type: "POST",
        data: {
          cacheId: cacheId,
          saveData: quoteDurationData
        },
        error: function (exc) {
          TECL_Master.ClearLock("ContinueNextStageSelectSuppliers");
        },
        success: function (partialViewHtml) {
          TECL_Master.ClearLock("ContinueNextStageSelectSuppliers");
          if (partialViewHtml) {
            $("#tenderPage").html(partialViewHtml);
          }
        }
      });
    }
  },

  // Vaidate the page
  ValidatePage: function () {
    $("#errShortTermDateAfterProductsDate").addClass("hidden");
    $("#errMidTermDateAfterProductsDate").addClass("hidden");
    $("#errLongTermDateAfterProductsDate").addClass("hidden");
    $("#errCustomDateAfterProductsDate").addClass("hidden");

    // Org selection validation fields
    var $singleSchoolNotSearched = $("#errSingleSchoolNotSearched");
    var $matSchoolNotSearched = $("#errMatSchoolNotSearched");
    var $matSchoolNotSelected = $("#errMatSchoolsNotSelected");
    $singleSchoolNotSearched.addClass("hidden");
    $matSchoolNotSearched.addClass("hidden");
    $matSchoolNotSelected.addClass("hidden");

    $(".errLatestDate").each(function () {
      $(this).addClass("hidden");
    });
    $(".errEndDateBeforeToday").each(function () {
      $(this).addClass("hidden");
    });

    // Validate Controls
    var noErrors = true;
    if ($("#sameDayTenderQuote").is(":checked")) {

      var datesAreValid = TECL_TenderQuoteDuration.ValidateDateRange($("#sameDateLatestDateVal"),
        $("#errQuoteDurationLatestDate"), $("#errQuoteDurationEndDateBeforeToday"));

      if (!datesAreValid) {
        // Invalid so show the error
        noErrors = false;
      }
    } else {

      $("#TenderProductDateSettingItems").find(".quoteDateDates").each(function () {

        var datesAreValid = TECL_TenderQuoteDuration.ValidateDateRange($(this).find(".latestDate"),
          $(this).find(".errLatestDate"), $(this).find(".errEndDateBeforeToday"));

        if (!datesAreValid) {
          // Invalid so show the error and open the panel if it not already
          noErrors = false;
          $(this).parents(".panel-collapse").collapse("show");
        } else {
          // Close any open panels that are valid and open so the invalid ones are highlighted
          $(this).parents(".panel-collapse").collapse("hide");
        }
      });
    }

    var todaysDate = new Date();
    var productDeliveryDate = $("#sameDateLatestDateVal").data("DateTimePicker").date();

    if ($("#quoteDurationShortTerm").is(":checked")) {
      if (productDeliveryDate) {
        var shortTenderCloseDate = new Date();
        shortTenderCloseDate.setDate(todaysDate.getDate() + 14);

        if (shortTenderCloseDate > productDeliveryDate) {
          $("#errShortTermDateAfterProductsDate").removeClass("hidden");
          noErrors = false;
        }
      }
    } else if ($("#quoteDurationMidTerm").is(":checked")) {
      if (productDeliveryDate) {
        var midTenderCloseDate = new Date();
        midTenderCloseDate.setDate(todaysDate.getDate() + 28);

        if (midTenderCloseDate > productDeliveryDate) {
          $("#errMidTermDateAfterProductsDate").removeClass("hidden");
          noErrors = false;
        }
      }
    } else if ($("#quoteDurationLongTerm").is(":checked")) {
      if (productDeliveryDate) {
        var longTenderCloseDate = new Date();
        longTenderCloseDate.setDate(todaysDate.getDate() + 42);

        if (longTenderCloseDate > productDeliveryDate) {
          $("#errLongTermDateAfterProductsDate").removeClass("hidden");
          noErrors = false;
        }
      }
    } else if ($("#quoteDurationUserDefinedTerm").is(":checked")) {
      var specificDatesAreValid = TECL_TenderQuoteDuration.ValidateDateRange($("#quoteUserDefinedDate"),
        $("#errUserDefinedTermDateInvalid"), $("#errUserDefinedTermDateBeforeToday"));
      if (!specificDatesAreValid) {
        // Invalid so show the error
        noErrors = false;
      } else if (productDeliveryDate) {

        // Check we don't overlap the product delivery date
        var customTenderCloseDate = $("#quoteUserDefinedDate").data("DateTimePicker").date();

        if (customTenderCloseDate > productDeliveryDate) {
          $("#errCustomDateAfterProductsDate").removeClass("hidden");
          noErrors = false;
        }
      }
    }

    // Org selection validation
    var singleSchoolMode = $("#singleSchoolSearch").is(":visible");

    if (singleSchoolMode) {

      // If there is no single school selected, show validation
      if (!$("#singleSchoolSearchOrgId").val()) {
        $singleSchoolNotSearched.removeClass("hidden");
        noErrors = false;
      }
    } else {

      // MAT school option
      if ($("#matSchoolSearchOrgId").val()) {

        // If the options are showing but none are selected
        if ($(".mat-school-options .checkbox.item-checked:visible").length <= 0) {

          $matSchoolNotSelected.removeClass("hidden");
          noErrors = false;
        }
      } else {

        // No MAT school selected
        $matSchoolNotSearched.removeClass("hidden");
        noErrors = false;
      }
    }

    // Scroll to first error message
    if (!noErrors) {
      $("html, body").animate({
        scrollTop: ($(".field-validation-error:visible").first().offset().top - 100)
      }, 500);
    }

    return noErrors;
  },

  // Get the Serialised Data
  SerialisedData: function () {

    //get standard data
    var sameDayQuote = $("#sameDayTenderQuote").is(":checked");
    var sameDayLatestDate = TECL_DateTime.GetDateTimePickerStringValue($("#sameDateLatestDateVal"));
    //var sameDayNotes = $("#sameDateNoteVal").val();
    var quoteUserDefinedDate = TECL_DateTime.GetDateTimePickerStringValue($("#quoteUserDefinedDate"));

    var durationSetting;
    if ($("#quoteDurationShortTerm").is(":checked")) {
      durationSetting = 1;
    } else if ($("#quoteDurationMidTerm").is(":checked")) {
      durationSetting = 2;
    } else if ($("#quoteDurationLongTerm").is(":checked")) {
      durationSetting = 3;
    } else if ($("#quoteDurationUserDefinedTerm").is(":checked")) {
      durationSetting = 4;
    } else {
      // Should never get here
      durationSetting = 3;
    }

    var productDateDatas = [];

    // Get products data
    $("#TenderProductDateSettingItems")
      .find(".panel-body")
      .each(function () {
        var latestDate = TECL_DateTime.GetDateTimePickerStringValue($(this).find(".latestDate"));
        var dateNotes = $(this).find(".quoteDateNoteVal").val();

        productDatesData = {
          LatestDate: latestDate,
          DateNotes: dateNotes
        }

        productDateDatas.push(productDatesData);
      });

    // Get the selected school data
    var singleSearch = $("#singleSchoolSearch").is(":visible");
    var selectedMainOrgId;
    var selectedMainOrgName;
    var selectedChildSchools = null;

    if (singleSearch) {

      selectedMainOrgId = $("#singleSchoolSearchOrgId").val();
      selectedMainOrgName = $("#singleSchoolSearch").val();
    } else {

      selectedMainOrgId = $("#matSchoolSearchOrgId").val();
      selectedMainOrgName = $("#matSchoolSearch").val();
      var $selectedSchools = $(".mat-school-options .checkbox.item-checked:visible");

      if ($selectedSchools.length > 0) {

        selectedChildSchools = "";
        $selectedSchools.each(function () {
          var orgId = $(this).attr("data-orgId");
          selectedChildSchools += (orgId + ",");
        });
        // Remove extra comma
        selectedChildSchools = selectedChildSchools.slice(0, -1);
      }
    }

    var quoteDurationData = {
      AllItemQuotedOnSameDay: sameDayQuote,
      SameDayLatestDate: sameDayLatestDate,
      SameDayNotes: "",
      DurationSetting: durationSetting,
      ProductDateDatas: productDateDatas,
      QuoteUserDefinedDate: quoteUserDefinedDate,
      SelectedOrgId: selectedMainOrgId,
      SelectedOrgName: selectedMainOrgName,
      MatSchoolSelected: !singleSearch,
      MatSelectedChildSchools: selectedChildSchools
    }
    return quoteDurationData;
  },

  // Validate date ranges
  ValidateDateRange: function (finishDateCntrl, errorEndDateEmptyCntrl, errorEndDateBeforeTodayCntrl) {
    $(errorEndDateEmptyCntrl).addClass("hidden");
    $(errorEndDateBeforeTodayCntrl).addClass("hidden");

    var datesAreValid = true;
    if (finishDateCntrl) {
      var finishDate = finishDateCntrl.data("DateTimePicker").date();

      var errorEndDateEmpty = false;
      var errorEndDateBeforeToday = false;
      var dateNow = Date();

      if (finishDate) {
        if (moment(finishDate).isSameOrBefore(dateNow)) {
          errorEndDateBeforeToday = true;
        }
      } else {
        errorEndDateEmpty = true;
      }

      if (errorEndDateEmpty) {
        $(errorEndDateEmptyCntrl).removeClass("hidden");
        datesAreValid = false;
      }

      if (errorEndDateBeforeToday) {
        $(errorEndDateBeforeTodayCntrl).removeClass("hidden");
        datesAreValid = false;
      }

    }
    return datesAreValid;
  }

};